// import React, { Component } from "react";

import ic_close from "../../assets/icons/ic_close.svg";
import { GAME_TO_FILE_MAP } from "../games/game_id";

// const sh = window.innerHeight;

// class GamePage extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       isOpen: false,
//     };

//     this.toggle = this.toggle.bind(this);
//   }

//   toggle() {
//     this.setState({
//       isOpen: !this.state.isOpen,
//     });
//   }

//   render() {
//     // const id = useParams()
//     // let { path, url } = useRouteMatch();
//     // console.log("id", id);
//     if (this.props.location.para === undefined) return <ErrorPage />;

//     return (
//       <div
//         style={{
//           backgroundColor: "#000000",
//           minHeight: "100vh",
//         }}
//       >
//         <div>
//           <Navbar
//             className="navbar_header"
//             expand="md"
//             style={{ position: "relative" }}
//           >
//             <NavbarBrand href="/">
//               <img
//                 src={aniamated_gif}
//                 alt="upugo logo"
//                 style={{
//                   position: "fixed",
//                   top: "0",
//                   left: "25px",
//                   height: "100px",
//                   width: "200px",
//                 }}
//               />
//             </NavbarBrand>
//             <NavbarToggler
//               onClick={this.toggle}
//               style={{
//                 position: "fixed",
//                 right: "30px",
//                 background: "#ffffff",
//               }}
//             />
//             <Collapse
//               isOpen={this.state.isOpen}
//               navbar
//               className="justify-content-center"
//             >
//               <Nav className="mr-auto navbar_nav" navbar>
//                 <NavItem>
//                   <NavLink
//                     // href="/homepage"
//                     className="navbar_item "
//                     style={{ fontSize: "20px" }}
//                   >
//                     {this.props.location.para.title}
//                   </NavLink>
//                 </NavItem>
//                 <NavItem></NavItem>
//               </Nav>
//               <NavbarText style={{ position: "absolute", right: "30px" }}>
//                 <a href="/homepage">
//                   <button
//                     type="button"
//                     onClick={this.togglemodal}
//                     className="btn btn-light gradient_btn"
//                     style={{ width: "140px", margin: "0 15px" }}
//                   >
//                     Close
//                   </button>
//                 </a>
//               </NavbarText>
//             </Collapse>
//           </Navbar>
//         </div>

//         <div className="container-fluid">
//           {/* {GAME_TO_FILE_MAP[this.props.location.para.id][1]} */}
//           {GAME_TO_FILE_MAP['@1'][1]}
//         </div>
//         <div className="row text-white mt-3">
//           <div className="col-12 col-sm-12 col-md-12">
//             <p style={{ float: "right", fontSize: "12px" }}>
//               Copyright <span>&#169;</span> upUgo2020
//             </p>

//           </div>
//         </div>
//       </div>
//     );
//   }
// }

// export default GamePage;

import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import IconButton from "../basic/IconButton";

const sh = window.innerHeight;

const GamePage = () => {
  let { gameId } = useParams();

  const navigate = useNavigate();

  return (
    <div className="w-full bg-black justify-center flex">
      <div
        style={{
          backgroundColor: "#000000",
        }}
      >
        <div className="w-full flex justify-end items-end pt-10">
          <IconButton
            icon={ic_close}
            className="shadow-xl flex justify-end"
            onClick={() => navigate("/programpage")}
          />
        </div>

        <div className="container-fluid">
          {/* {GAME_TO_FILE_MAP[this.props.location.para.id][1]} */}
          {GAME_TO_FILE_MAP[`${gameId}`][1]}
        </div>
      </div>
    </div>
  );
};

export default GamePage;
